import { useLayoutEffect, useState, type RefObject } from "react";

export function useSuggestionsHeight(
  anchorRef: RefObject<HTMLElement | null>,
  visible: boolean,
): number {
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const anchor = anchorRef.current;
    const box =
      visible && anchor ? anchor.querySelector<HTMLElement>("[data-suggestions-box]") : null;
    if (!box) {
      setHeight(0);
      return;
    }

    const update = () => setHeight(box.offsetHeight);

    update();
    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(box);

    return () => resizeObserver.disconnect();
  }, [anchorRef, visible]);

  return height;
}
